import { Image } from "react-datocms";

export const ResourcesWrapper = ({children, dark = false}) => {
    return <>
        <div className={"resources " + (dark && "dark")}>
            <div className="resources__content">
                {children}
            </div>
        </div>
        <style jsx>
            {`
            .resources {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                width: 100vw;
                min-height: 50vh;
                height: max-content;
                background: var(--off-white);
                position: relative;
                overflow: hidden;
            }
            .resources.dark {
                background-color: transparent;
                color: #fff;
            }
            :global(.resources.dark .resources__cards) {
                margin-top: 2rem;
                margin-bottom: 2rem;
                padding: 0;
            }
            :global(.resources.dark .resources__cards) {
                flex-wrap: wrap;
                width: 100%;
            }
            :global(.resources.dark .resources__card) {
                display: flex;
                flex-direction: row;
                justify-content: start;
                align-items: center;
                flex: 1 1 calc(25% - 1.5rem);
                min-width: 200px;
                height: 100%;
                border-radius: var(--border-radius);
                background-color: var(--covalent-dark-blue);
                transform: translate(0);
                transform-style: preserve-3d;
                height: auto;
                z-index: 1;
                position: relative;
                border: 1px solid var(--black-light);
            }

            :global(.resources.dark .resources__description) {
                color: var(--gray-medium);
            }

            :global(.resources.dark .resources__card:hover) {
                border: 1px solid var(--pink);
                transition: all 0.2s ease-in-out;
            }

            @keyframes backgroundGradient {
                0% {
                    background-position: 0% 50%;
                    transform: scale(1.01);
                }
                100% {
                    background-position: 100% 50%;
                    transform: scale(0.98);
                }
            }

            :global(.resources.dark .resources__card::before) {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-image: linear-gradient(45deg, #ff4c8b80, var(--teal));
                z-index: -1;
                filter: blur(5px);
                border-radius: calc(var(--border-radius) * 2);
                animation: backgroundGradient 4s ease-in-out infinite alternate;
                background-size: 200% 200%;
                // opacity: 0.85;
                transition: all 0.2s ease-in-out;
            }

            :global(.resources.dark .resources__card:hover::before) {
                filter: blur(25px);
                transition: all 0.2s ease-in-out;
                background-image: linear-gradient(45deg, var(--pink), var(--teal));
            }

            :global(.resources.dark .resources__card::after) {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: var(--covalent-dark-blue);
                z-index: -1;
                border-radius: calc(var(--border-radius) * 2);
                // opacity: 0.85;
            }
            :global(.resources.dark .resources__card:hover::after) {
                background-image: linear-gradient(135deg,#00d8d521 0%,#ff4c8b33 100%);
            }
            .resources__content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                height: max-content;
                padding: var(--landing-page-padding);
                max-width: var(--landing-page-max-width);
                margin: 0 auto;
                width: 100%;
            }
            @media (max-width: 768px) {
                .resources {
                    flex-direction: column;
                    height: auto;
                }
                .resources__content {
                    width: 100%;
                    height: auto;
                    padding: var(--landing-page-padding);
                }
            }
        `}
        </style>
    </>;
};

export const ResourcesTitle = ({children}) => {
    return <><h2>
        {children}
    </h2>
    <style jsx>
        {`
            h2 {
                font-size: var(--font-size-7);
                margin-bottom: 1rem;
                line-height: 1.2;
                z-index: 1;
            }
            @media screen and (max-width: 768px) {
                h2 {
                    font-size: var(--font-size-5)
                }
            }
        `}
    </style>
    </>;
};

export const ResourcesSubtitle = ({children}) => {
    return <>
        <p>
            {children}
        </p>
        <style jsx>
            {`
            p {
                font-size: var(--font-size-4);
                margin-bottom: 1rem;
            }
        `}
        </style>
    </>;
};

export const ResourcesCtas = ({children}) => {
    return <><div className="resources__cta">
        {children}
    </div>
    <style jsx>
        {`
            :global(.resources__cta:nth-child(2) button) {
                background-color: #fff;
                color: var(--pink);
                border: 1px solid var(--pink);
            }
            :global(.resources__cta:nth-child(2) button):hover {
                background-color: var(--pink);
                color: #fff;
                border: 1px solid var(--pink);
            }
            .resources__cta {
                gap: 1rem;
                display: flex;
                margin-top: var(--landing-page-gap);
            }
        `}
    </style>
    </>;
};

export const ResourcesCta = ({children}) => {
    return <div className="resources__cta">
        {children}
    </div>;
};

export const ResourcesCard = ({children, link}) => {
    return <><a href={link} target="_blank" className="gradient-border resources__card" >
        {children}
    </a>
    <style jsx>
        {`
            a {
                display: flex;
                place-items: center;
                flex-direction: row;
                justify-content: start;
                align-items: start;
                width: 100%;
                gap: var(--landing-page-gap);
                border: 1px solid var(--code-border);
                padding: 1rem var(--landing-page-gap);
                border-radius: calc(var(--border-radius) * 1);
                height: auto;
                position: relative;
                background: #fff;
                text-decoration: none;
                cursor: pointer;
                color: var(--gray-medium);
            }

            a:hover {
                // opacity: 0.8;
                color: #fff;
            }
            
            @media (max-width: 768px) {
                a {
                    flex-direction: row;
                    place-items: start;
                }
            }
        `}
    </style></>;
};


export const ResourcesCards = ({children}) => {
    return <><div className="resources__cards">
        {children}
    </div>
    <style jsx>
        {`
            div {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                grid-gap: var(--landing-page-gap);
                width: 100%;
            }
            @media (max-width: 768px) {
                div {
                    grid-template-columns: repeat(1, 1fr);
                }
            }
            @media (max-width: 1100px) {
                div {
                    grid-template-columns: repeat(1, 1fr);
                }
            }
        `}
    </style></>;
};

export const ResourcesCardCTA = ({children}) => {
    return <><div>
        {children}
    </div>
    <style jsx>
        {`
            div {
                margin-top: auto;
            }
        `}
    </style></>;
};

export const ResourcesCardTitle = ({children}) => {
    return <><h3>
        {children}
    </h3>
    <style jsx>
        {`
            div {
                font-size: var(--font-size-5);
                color: var(--pink);
            }
            h3 {
                font-size: var(--font-size-5);
                margin-bottom: 1rem;
                margin-top: 0;
                margin: 0;
            }
            @media (max-width: 768px) {
                h3 {
                    font-size: var(--font-size-3);
                }
            }
        `}
    </style></>;
};

export const ResourcesCardDescription = ({children}) => {
    return <><p className="resources__description">
        {children}
    </p>
    <style jsx>
        {`
            p {
                color: var(--black-light);
            }
        `}
    </style></>;
};

export const ResourcesCardIcon = ({src}) => {
    return <><div>
        <img src={src} alt="Resource Icon" />
    </div>
    <style jsx>
        {`
            img {
                height: 32px;
                width: 32px;
            }
            @media (max-width: 768px) {
                img {
                    height: 24px;
                    width: 24px;
                }
            }
        `}
    </style></>;
};

export const ResourcesCardImage = ({src}) => {
    return <><div className="image">
        <Image data={src}  usePlaceholder={false} />
    </div>
    <style jsx>
        {`
           .image {
                max-width: 8rem;
           }
        `}
    </style></>;
};

export const ResourcesBadge = ({children}) => {
    return <><div>
        {children}
    </div>
    <style jsx>
        {`
            div {
                font-size: var(--font-size-5);
                margin-bottom: 1rem;
                color: var(--pink);
            }
        `}
    </style></>;
};